// extracted by mini-css-extract-plugin
export default {"home":"Ventures_home__X+pTo","container":"Ventures_container__CTI5x","heading":"Ventures_heading__M55ov","mind":"Ventures_mind__oL1mU","zuhaus":"Ventures_zuhaus__j85H1"};